import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getDynamicPage } from '../../lib/sqlAuth';
import { subscribeCmsUpdates } from '../../lib/cmsSync';
import SectionRenderer from './SectionRenderer';

export default function DynamicPage({ page = '', slugOverride = '', fallback = null }) {
  const params = useParams();
  const routeSlug = String(params?.slug || '').trim().toLowerCase();
  const resolvedPage = String(page || slugOverride || routeSlug || 'home').trim().toLowerCase();
  const [pageMeta, setPageMeta] = useState(null);
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let mounted = true;

    const load = async () => {
      setLoading(true);
      setFailed(false);
      try {
        const res = await getDynamicPage({ page: resolvedPage });
        if (!mounted) return;
        setPageMeta(res?.page || null);
        setSections(Array.isArray(res?.sections) ? res.sections : []);
      } catch (_) {
        if (!mounted) return;
        setFailed(true);
        setPageMeta(null);
        setSections([]);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    load();
    const unsubscribe = subscribeCmsUpdates(() => load());
    return () => {
      mounted = false;
      unsubscribe();
    };
  }, [resolvedPage]);

  useEffect(() => {
    if (!pageMeta) return;
    if (pageMeta.metaTitle) {
      document.title = pageMeta.metaTitle;
    }

    const description = pageMeta.metaDescription || '';
    let tag = document.querySelector('meta[name="description"]');
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('name', 'description');
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', description);
  }, [pageMeta]);

  if (loading) {
    return <div style={{ minHeight: '60vh' }} />;
  }

  if (failed || !pageMeta) {
    if (fallback) return fallback;
    return (
      <section style={{ minHeight: '60vh', padding: '80px 16px', textAlign: 'center' }}>
        <h2>Page not found</h2>
      </section>
    );
  }

  return (
    <main>
      {sections.map((section) => (
        <SectionRenderer key={section.id} section={section} />
      ))}
    </main>
  );
}
